<template>
  <div class="grid row ">
    <div class="flex xs12 md12">
      <va-card>
        <va-card-content class="ant-space ant-space-vertical" style="width:100%;padding-bottom:0;">
          <a-breadcrumb>
            <a-breadcrumb-item>
              <router-link to="/admin/dashboard" tag="a">Home / </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
              <router-link to="/admin/forum/forumindex" tag="a">社区主页 / </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
              <router-link :to="$route.path" tag="a">{{ $route.name }}</router-link>
            </a-breadcrumb-item>
            <!-- <a-breadcrumb-item>我要发贴</a-breadcrumb-item> -->
          </a-breadcrumb>
          <div class="ant-row">
            <div style="flex:8;">
              <va-input v-model="searchValue" placeholder="搜索帖子或者问题..." outline/>
            </div>
            <div style="flex:4;">
              <va-button :rounded="false" text-color="#ffffff" icon-right="search" style="border-radius:unset;"
                         @click="searchClick"></va-button>
              <va-icon name="menu" size="36px" color="blank" @click="showFilter" style="margin:0 20px;"/>

            </div>
          </div>
          <div style="    margin-top: 10px;color: #666;font-size: 14px;">
            关于{{ searchValue }}的搜索结果， 共{{ tablePager.totalResult }}条
          </div>
        </va-card-content>
        <va-inner-loading :loading="isLoading" style="width: 100%;" color="primary">
          <va-card-content style="background:#fff;display:flex;align-items: center;" v-if="isShowFilter">

            <div class="flex md5 xs11" style="padding-left:0;">
              <h2>筛选标签：</h2>
              <a-select
                mode="multiple"
                allowClear
                v-model:value="tagValue"
                notFoundContent="暂无数据"
                optionLabelProp="label"
                placeholder="请选择选项"
                :options="options.map(item => ({ label: item.Name, value: item.ID ,IsTab: item.IsTab,Ord: item.Ord}))"
                style="width: 100%">

              </a-select>
            </div>
            <div class="flex md5 xs11" style="margin-right:20px;">
              <h2>筛选分类：</h2>
              <a-cascader :show-search="{ selectFilter }" v-model:value="classValue" @change="handleChange"
                          style="width:100%;" placeholder="请选择分类" notFoundContent="暂无数据"
                          :options="classOptions"
                          change-on-select :fieldNames="{ label: 'Name', value: 'ID', children: 'Children' }"/>
            </div>
            <div class="flex md2 xs2">
              <a-checkbox v-model:checked="checked">仅精华帖</a-checkbox>
            </div>
          </va-card-content>
        </va-inner-loading>
      </va-card>
    </div>
    <div class="flex xs12 md12" :style="{'height':pageHeight}">
      <va-card>
        <va-card-content v-for="(item,index) in wordList" :key="index">
          <div>
            <router-link :to="{path:'/admin/forum/postsPage/postsContent',query:{searcharticle:item.ID}}">
              <div class="search-head" v-html="searchWordFilter(item.Title,searchValue)"></div>
            </router-link>
            <div>
              <!-- <span class="search-link">{{item.FilePath}}</span> -->
              <span class="search-time">{{ item.CreateTime }}</span></div>
            <!-- <div class="search-profile" v-html="searchWordFilter(item.Contents,searchValue)"></div> -->
            <div class="search-profile">{{ item.Contents }}</div>
            <a class="compile-a" style="text-align:left;" target="_blank" :href="item.FilePath"
               v-if="item.FilePath && item.IsPlay != 1">
              <va-icon class="icon-left input-icon" name="file_download"/>
              {{ item.FileName }}</a>
          </div>
        </va-card-content>
        <va-card-content>
          <div>
            <vxe-pager
              background
              v-model:current-page="tablePager.currentPage"
              v-model:page-size="tablePager.pageSize"
              :total="tablePager.totalResult"
              @page-change="handlePageChange"
              :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
            </vxe-pager>
          </div>
        </va-card-content>
      </va-card>
    </div>
  </div>
</template>
<script>
import {computed, toRow, defineComponent, ref, reactive, getCurrentInstance} from 'vue';
import postsMinxin from './postsMinxin.js';
import Qs from 'qs';

export default defineComponent({
  mixins: [postsMinxin],
  data() {
    const pageHeight = window.innerHeight - (65 + 136 + 72) + 'px';
    const {proxy} = getCurrentInstance();
    const options = proxy.$store.state.tabOptions, classOptions = proxy.$store.state.classOptions;
    const isShowFilter = ref(false)
    const searchValue = ref('')
    const showFilter = () => {
      isShowFilter.value = !isShowFilter.value;
    }
    // const searchWordFilter = (textVal, filterKey) => {

    //     const Reg = new RegExp(filterKey, 'gi');
    //     if (textVal) {
    //         return textVal.replace(Reg, `<span style="color:red;">${filterKey}</span>`);
    //     }

    // }
    const wordList = reactive([])
    const tagValue = reactive([])
    const classValue = reactive([])
    return {
      pageHeight,
      wordList,
      isShowFilter,
      // searchWordFilter,
      showFilter,
      searchValue,
      options,
      classOptions,
      tagValue,
      checked: ref(false),
      classValue,
      isLoading: false
    }
  },
  mounted(params) {

    if (this.$store.state.searchData != '') {
      let parseVal = JSON.parse(this.$store.state.searchData);
      console.log(parseVal)
      this.classValue = parseVal.Category;
      this.tagValue = parseVal.Label;
      this.searchValue = parseVal.KeyWord;
      this.checked = parseVal.IsElite;

    }
    window.addEventListener("keydown", this.keydown);

    this.searchClick()

  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  methods: {
    searchWordFilter(textVal, filterKey) {
      if (filterKey == undefined) {
        return textVal;
      }
      // console.log(textVal)
      const Reg = new RegExp(filterKey, 'gi');
      if (textVal) {
        return textVal.replace(Reg, `<span style="color:red;">${filterKey}</span>`);
      }

    },
    searchClick() {
      this.isLoading = true;
      console.log(this.tagValue == undefined)
      let params = {
        "SectionID": "",//版块ID
        "Label": this.tagValue == undefined ? '' : this.tagValue.join(','), //标签ID，用‘,’隔开
        "isshow": '1',//可见1
        "KeyWord": this.searchValue, //查询关键字，标题或内容
        "Category": this.classValue == undefined || this.classValue.length == 0 ? '' : this.classValue[this.classValue.length - 1], //类别ID
        "IsElite": this.checked ? 1 : '', //1 精华；空或其他，全部
        "Creator": '', //发布人UID
        "TimeSpan": "", //0 今天 1 三天内 2 一周内 3 一月内 4 半年内
        "Order": "", //0 最近更新 1 最新发布 2 点赞数 3 回复数
        "currentPage": this.tablePager.currentPage, //当前页
        "pageSize": this.tablePager.pageSize//页大小
      }, resData;
      this.$api.formsAPI.getForumArticle(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          this.wordList = reactive(res.data.Data.dataTable);
          console.log(res.data.Data)
          // this.$store.commit('updateSearchData','');
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        })
    },
    handlePageChange() {
      this.searchClick()
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.searchClick();
      }
    }
  }
})
</script>
<style src="./css/antd.css"></style>
<style scoped>
.compile-a {
  width: 100%;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.search-head {
  font-size: 16px;
  margin-bottom: 8px;
  color: #0366d6;
  font-weight: 600;
}

.search-link {
  margin-right: 6px;
  color: #008100;
  text-decoration: none;
}

.search-time {
  color: #999;
}

.search-profile {
  line-height: 1.4;
  font-size: 14px;
  color: #4d4d4d;
  width: 100%;
  position: relative;
  /* // max-width:220px; */
  /* font-weight:800; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* display: block; */
}
</style>
